import {IAbTestingFeature} from "./ab-testing-feature-data-provider.service.interface";

export interface IFeatureToggleViewModel {
    readonly isEnabled: boolean;
    getFeatureABData(): IAbTestingFeature | null;
}

export enum FeatureToggleStatusEnum {
    Disabled = 0,
    Enabled = 1,
    EnabledByAB = 2
}